import { FieldProps, getIn } from 'formik';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { FormikSelect } from '../../../../components/Form';
import { getNestedError } from '../../../../helpers/formikHelper';

type Props = {
  label: string;
} & FieldProps;

const LanguageSelect: React.FunctionComponent<Props> = ({ field, form, label }: Props) => {
  const { t } = useTranslation('global');
  const languages = [
    {
      label: t('languages.en'),
      value: 'EN',
    },
    {
      label: t('languages.nl'),
      value: 'NL',
    },
    {
      label: t('languages.fr'),
      value: 'FR',
    },
    {
      label: t('languages.de'),
      value: 'DE',
    },
  ];

  return (
    <FormikSelect
      field={field}
      form={form}
      label={label}
      menuPosition={'fixed'}
      value={getIn(form.values, field.name)}
      getOptionValue={option => option.value}
      getOptionLabel={option => option.label}
      error={getNestedError(field.name, form.errors, form.touched)}
      options={languages}
    />
  );
};

export default LanguageSelect;
